import { render, staticRenderFns } from "./serviceAdmin.vue?vue&type=template&id=272b26cb&scoped=true"
import script from "./serviceAdmin.vue?vue&type=script&lang=js"
export * from "./serviceAdmin.vue?vue&type=script&lang=js"
import style0 from "./serviceAdmin.vue?vue&type=style&index=0&id=272b26cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272b26cb",
  null
  
)

export default component.exports